import { render, staticRenderFns } from "./RetailerMembers.vue?vue&type=template&id=76c70b70&lang=pug"
import script from "./RetailerMembers.vue?vue&type=script&lang=js"
export * from "./RetailerMembers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports